import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getLastDriversRequest } from 'store/modules/comuns/lastDrivers/reducer'
import { FormCombobox } from 'components/CoForm/components'

export function ComboboxLastDrivers(props) {
  const dispatch = useDispatch()
  const { loading, drivers } = useSelector((state) => state.comuns.lastDrivers)

  const options = useMemo(() => {
    return drivers.map((driver) => ({
      value: driver.wem_cpf,
      label: driver.wem_nome,
    }))
  }, [drivers])

  useEffect(() => {
    dispatch(getLastDriversRequest())
  }, [dispatch])

  return (
    <FormCombobox
      id="combo-last-drivers"
      options={options}
      loading={loading}
      {...props}
    />
  )
}

export default ComboboxLastDrivers
